import { RQParam, RQHandlers, RQService, RQApp } from '../../RQuery/RQuery';
import { dmHotel }                               from '../sign-in/xv-hotel';
import { MLText, mlBroker }                      from '../../services/MLText';
import { dmLoading }                             from '../loading/loading';

export class EnableViewModel {
    BackToSignIn:          ()                 => void;
    NewLoading:            (pMessage: string) => dmLoading;

    mlText:                MLText;
    app:                   mlBroker;
    ml:                    mlBroker;
    Hotel:                 dmHotel;
    LangID:                number;

    HasEntry:              boolean;

    CanSetNonRef:          boolean;
    CanSetMemberOnly:      boolean;
    CanSetEarlyBird:       boolean;
    CanSetWalkIn:          boolean;

    AllowNonRef:           boolean;
    AllowNonRefByDiscount: boolean;
    AllowNonRefByCM:       boolean;
    AllowMemberOnly:       boolean;
    AllowLastMinute:       boolean;
    AllowEarlyBird:        boolean;
    AllowWalkIn:           boolean;

    NonRefDiscount:        number;
    MemberOnlyDiscount:    number;
    LastMinuteDiscount:    number;
    LastMinuteAvThreshold: number;
    EarlyBirdDiscount:     number;
    EarlyBirdAdvanceDays:  number;
    WalkInDiscount:        number;
    WalkInIsNonRef:        boolean;

    constructor(
         pMLText:       MLText
        ,pHotel:        dmHotel
        ,pBackToSignIn: () => void
        ,pNewLoading:   (pMessage: string) => dmLoading
    ) {
        this.mlText                = pMLText;
        this.LangID                = this.mlText.GetLangID();
        this.app                   = this.mlText.GetBroker(
            'BookingEngineAppTexts'
        );
        this.ml                    = this.mlText.GetBroker(
            'HotelAreaEnable'
        );

        this.Hotel                 = pHotel;
        this.BackToSignIn          = pBackToSignIn;
        this.NewLoading            = pNewLoading;

        this.HasEntry              = false;

        this.CanSetNonRef          = true;
        this.CanSetMemberOnly      = true;
        this.CanSetEarlyBird       = true;
        this.CanSetWalkIn          = true;

        this.AllowNonRef           = true;
        this.AllowNonRefByDiscount = true;
        this.AllowNonRefByCM       = false;
        this.AllowMemberOnly       = true;
        this.AllowLastMinute       = true;
        this.AllowEarlyBird        = true;
        this.AllowWalkIn           = true;

        this.NonRefDiscount        = 10;
        this.MemberOnlyDiscount    = 10;
        this.LastMinuteDiscount    = 20;
        this.LastMinuteAvThreshold = 2;
        this.EarlyBirdDiscount     = 15;
        this.EarlyBirdAdvanceDays  = 28;
        this.WalkInDiscount        = 30;
        this.WalkInIsNonRef        = true;

        this.refreshSettings();
    }

    private refreshSettings(): void {
        let loading = this.NewLoading(
            this.app.Text('LoadingMark', 'Loading...')
        );

        loading.Show(() => {
            let settingsParams = RQParam.OtaGetHotelDiscountSettingsStatusParams();

            settingsParams.HotelID = this.Hotel.HotelID;

            RQService.Ota.GetHotelDiscountSettingsStatus(settingsParams).then((result) => {
                let response = result as any;

                if (response.HasErrorOrException) { loading.Dismiss(); return; }

                let settingsList = response.RQueryResult;

                let settings = RQService.Ota.PopulateGetHotelDiscountSettingsStatusRow(
                    settingsList[0]
                );

                this.HasEntry              = (settings.HasEntry            == 1);

                this.CanSetNonRef          = (settings.CanSetAutoNonRef    == 1);
                this.CanSetMemberOnly      = (settings.CanSetMemberOnly    == 1);
                this.CanSetEarlyBird       = (settings.CanSetAutoEarlyBird == 1);
                this.CanSetWalkIn          = (settings.CanSetAutoWalkIn    == 1);

                this.AllowNonRef           = (settings.AllowAutoNonRef     == 1);
                this.AllowMemberOnly       = (settings.AllowAutoMemberOnly == 1);
                this.AllowLastMinute       = (settings.AllowAutoLastMintue == 1);
                this.AllowEarlyBird        = (settings.AllowAutoEarlyBird  == 1);
                this.AllowWalkIn           = (settings.AllowAutoWalkIn     == 1);

                this.AllowNonRefByCM       = (settings.NonRefByCM     == 1);
                this.NonRefDiscount        = settings.NonRefDiscount;
                this.MemberOnlyDiscount    = settings.MemberOnlyDiscount;
                this.LastMinuteDiscount    = settings.LastMinuteDiscount;
                this.LastMinuteAvThreshold = settings.LastMinuteAvThreshold;
                this.EarlyBirdDiscount     = settings.EarlyBirdDiscount;
                this.EarlyBirdAdvanceDays  = settings.EarlyBirdAdvanceDays;
                this.WalkInDiscount        = settings.WalkInDiscount;
                this.WalkInIsNonRef        = (settings.WalkInIsNonRef == 1);

                if (!this.CanSetNonRef) {
                    this.AllowNonRef           = false;
                    this.AllowNonRefByCM       = false;
                    this.AllowNonRefByDiscount = false;
                } else if (this.AllowNonRef) {
                    if (this.AllowNonRefByCM) {
                        this.AllowNonRefByDiscount = false;
                    } else {
                        this.AllowNonRefByDiscount = true;
                    }
                } else {
                    this.AllowNonRefByCM       = false;
                    this.AllowNonRefByDiscount = false;
                }

                loading.Dismiss();
            });
        });
    }

    public ToggleNonRefByCM(): void {
        if (this.CanSetNonRef) {
            this.AllowNonRefByCM = !this.AllowNonRefByCM

            if (this.AllowNonRefByCM) { this.AllowNonRefByDiscount = false; }

            this.AllowNonRef = (this.AllowNonRefByCM || this.AllowNonRefByDiscount);
        }
    }

    public ToggleNonRefByDiscount(): void {
        if (this.CanSetNonRef) {
            this.AllowNonRefByDiscount = !this.AllowNonRefByDiscount

            if (this.AllowNonRefByDiscount) { this.AllowNonRefByCM = false; }

            this.AllowNonRef = (this.AllowNonRefByCM || this.AllowNonRefByDiscount);
        }
    }

    public Save(): void {
        let loading = this.NewLoading(
            this.app.Text('SavingMark', 'Saving...')
        );

        if (!this.CanSetNonRef) {
            this.AllowNonRef           = false;
            this.AllowNonRefByCM       = false;
            this.AllowNonRefByDiscount = false;
        } else {
            this.AllowNonRef = (this.AllowNonRefByCM || this.AllowNonRefByDiscount);
        }

        loading.Show(() => {
            let saveParams = RQParam.OtaSetHotelDiscountSettingsStatusParams();

            saveParams.HotelID               = this.Hotel.HotelID;
            saveParams.AllowAutoNonRef       = (this.AllowNonRef)     ? 1 : 0;
            saveParams.AllowAutoMemberOnly   = (this.AllowMemberOnly) ? 1 : 0;
            saveParams.AllowAutoLastMintue   = (this.AllowLastMinute) ? 1 : 0;
            saveParams.AllowAutoEarlyBird    = (this.AllowEarlyBird)  ? 1 : 0;
            saveParams.AllowAutoWalkIn       = (this.AllowWalkIn)     ? 1 : 0;
            saveParams.NonRefDiscount        = this.NonRefDiscount;
            saveParams.NonRefByCM            = (this.AllowNonRefByCM) ? 1 : 0;
            saveParams.MemberOnlyDiscount    = this.MemberOnlyDiscount;
            saveParams.LastMinuteDiscount    = this.LastMinuteDiscount;
            saveParams.LastMinuteAvThreshold = this.LastMinuteAvThreshold;
            saveParams.EarlyBirdDiscount     = this.EarlyBirdDiscount;
            saveParams.EarlyBirdAdvanceDays  = this.EarlyBirdAdvanceDays;
            saveParams.WalkInDiscount        = this.WalkInDiscount;
            saveParams.WalkInIsNonRef        = (this.WalkInIsNonRef) ? 1 : 0;
            saveParams.LangID                = this.LangID;

            RQService.Ota.SetHotelDiscountSettingsStatus(saveParams).then((result) => {
                loading.Dismiss();

                let response = result as any;

                if (response.HasErrorOrException) {
                    this.refreshSettings();
                }
            });
        });
    }

    public SignOut(): void {
        this.Hotel.SignOut((pLogOutResult) => { this.BackToSignIn(); });
    }
}


// WEBPACK FOOTER //
// ./src/pages/enable/xv-enable.ts